import positionTypes from '../constants/position-types';

const invertAdjacentPosition = (position) => {
  if (position === positionTypes.BEFORE_BEGIN) {
    return positionTypes.AFTER_END;
  }

  if (position === positionTypes.AFTER_END) {
    return positionTypes.BEFORE_BEGIN;
  }

  return position;
};

export default invertAdjacentPosition;
